import type { InvitationTemplate } from './catalog';

export function TemplateEnvelopePreview({ template }: { template: InvitationTemplate }) {
  const { color, name } = template.envelope;
  return <div style={{ aspectRatio: '5 / 7', display: 'grid', alignContent: 'center', padding: 14, boxSizing: 'border-box' }}>
    <svg viewBox="0 0 400 286" role="img" aria-label={`${name} envelope with gold border and wax seal`} style={{ width: '100%', filter: 'drop-shadow(0 12px 10px #0002)' }}>
      <rect width="400" height="286" rx="3" fill={color}/>
      <path d="M0 0L200 156L400 0M0 286L155 147M400 286L245 147" fill="none" stroke="#c9a96e" strokeWidth="3"/>
      <path d="M0 0L200 156L400 0Z" fill="#ffffff0c"/>
      <circle cx="200" cy="155" r="25" fill="#c9a96e" stroke="#e8d9b8" strokeWidth="3"/>
      <text x="200" y="165" fill="#614b2d" fontFamily="Georgia" fontSize="30" textAnchor="middle">&amp;</text>
    </svg>
    <p style={{textAlign:'center',fontSize:13,marginTop:30,color:'#62594f'}}>{name} · Felt paper<br/>Gold-striped lining · Wax seal</p>
  </div>;
}
